import { NativeSelect, styled } from "@mui/material";

const SelectCustom = styled(NativeSelect)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(3),
  },
  "&.MuiInput-root:before": {
    border: "1px solid transparent",
    height: "100%",
    borderRadius: "8px",
  },
  "&.MuiInput-root:hover:not(.Mui-disabled):before": {
    border: "1px solid transparent",
  },
  "&.MuiInput-root.Mui-focused:not(.Mui-disabled):before": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
  "&.MuiInputBase-root.MuiInput-root:after": {
    border: "none",
  },
  "& .MuiNativeSelect-select": {
    backgroundColor: "#fff",
    fontSize: "12px",
    padding: "11px 12px",
    borderRadius: "8px",
  },
  "& .MuiNativeSelect-select.MuiInput-input:focus": {
    backgroundColor: "#fff",
  },
  "&.MuiInput-root.Mui-error .MuiNativeSelect-select": {
    backgroundColor: theme.palette.error.light,
    border: `1px solid ${theme.palette.error.main}`,
  },
}));

export default SelectCustom;
